import React from 'react';
import { useInView } from 'react-intersection-observer';
import { Calendar } from 'lucide-react';
import { useSectionData } from '../hooks/useSectionData';
import { fetchEducation, attr, getImageUrl } from '../services/api';

function fmtDate(d) {
  if (!d) return '';
  return new Date(d).toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
}

export default function Education() {
  const items = useSectionData(fetchEducation);
  const { ref, inView } = useInView({ threshold: 0.1, triggerOnce: true });

  if (!items) return null;

  return (
    <section id="education" ref={ref} className={`section${inView ? ' visible' : ''}`}>
      <div className="container">
        <header className="section-header">
          <p className="section-label">education</p>
          <h2 className="section-title">Education</h2>
          <div className="section-line" />
        </header>

        <div className="timeline">
          {items.map((item, i) => {
            const a = attr(item);
            const logo = getImageUrl(a.logo);
            const start = fmtDate(a.start_date);
            const end = a.is_current ? 'Present' : fmtDate(a.end_date);

            return (
              <div key={i} className="timeline-item">
                <div className="timeline-header">
                  <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
                    {logo && (
                      <img
                        src={logo}
                        alt={a.institution}
                        className="edu-logo"
                        loading="lazy"
                      />
                    )}
                    <div>
                      <p className="timeline-title">{a.degree}{a.field_of_study ? ` in ${a.field_of_study}` : ''}</p>
                      <p className="timeline-org">{a.institution}</p>
                      {a.board && <p className="timeline-meta" style={{ marginTop: 2 }}>{a.board}</p>}
                    </div>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 6 }}>
                    {a.is_current && <span className="current-badge">Current</span>}
                    {(start || end) && (
                      <span className="timeline-meta">
                        <Calendar size={12} />
                        {start}{end ? ` — ${end}` : ''}
                      </span>
                    )}
                    {a.grade && (
                      <span className="timeline-meta">GPA / Grade: {a.grade}</span>
                    )}
                  </div>
                </div>

                {a.description && (
                  <p className="timeline-body">{a.description}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
